<template>
  <div>
    journal page -- WIP
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>